import React, { Component, Fragment } from "react";
import {
  FormGroup,
  ControlLabel,
  Row,
  Col,
  FormControl,
  Checkbox,
} from "react-bootstrap";
import LoaderButton from "../../src/Component/LoaderButton";
import { fillDemoExpungmentForm } from "../libs/API";

class DemoExpungement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      caseNumber: "",
      caseDate: "",
      expDate: "",
      id: "",
      name: "",
      isAppendFile: "",
      isPrependExistingFile: "",
      isArrestFiles: false,
      isArrestRecords: false,
      isNonArresetFiles: false,
    };
    // console.log("DemoExpungement popup props", props);
  }

  async componentDidMount() {
    const selectedRow = this.props.selectedRow;
    let caseNumber = selectedRow[0]["Case Number"] || "";
    let caseDate = selectedRow[0].Date || "";
    this.setState({
      caseNumber,
      caseDate,
    });
  }

  handleDemoExpungementSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const jObject = {
      Docket: this.state.jacketNumber,
      ExpDate: this.props.getFormattedDate(new Date(this.state.expDate)),
      Case: this.state.caseNumber,
      CaseDate: this.props.getFormattedDate(new Date(this.state.caseDate)),
      Name: this.state.name,
    };

    const jArray = [];
    jArray.push(jObject);
    jArray.push({ fileId: this.props.selectedRow[0].FileId });
    const isAppendFile =
      this.state.isAppendFile === null || this.state.isAppendFile === ""
        ? false
        : true;
    const isPrependExistingFile =
      this.state.isPrependExistingFile === null ||
      this.state.isPrependExistingFile === ""
        ? false
        : true;
    jArray.push({
      isAppendFile: isAppendFile,
      isPrependExistingFile: isPrependExistingFile,
    });

    fillDemoExpungmentForm(jArray)
      .then((data) => {
        if (data.status === 200) {
          this.setState({ isLoading: false });
          this.props.closeParentPopup();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    return (
      <Fragment>
        <form onSubmit={this.handleDemoExpungementSubmit}>
          <FormGroup controlId="caseNumber">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Number:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  required
                  readOnly
                  value={this.state.caseNumber}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="caseDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Case Date:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  readOnly
                  value={this.state.caseDate}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="expDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Exp. Date:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  onChange={(e) => this.setState({ expDate: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="name">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Name:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="jacketNumber">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Docket#:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) =>
                    this.setState({ jacketNumber: e.target.value })
                  }
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={4}>
                <LoaderButton
                  block
                  bsClass="btn btn-outline-secondary"
                  disabled={this.state.isLoading}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Expunge Record"
                  loadingText="Expunging Record..."
                />
              </Col>
              <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({ isAppendFile: e.target.checked })
                  }
                >
                  {"   "} Append to Existing Expungement
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={4}></Col>
              <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({
                      isPrependExistingFile: e.target.checked,
                    })
                  }
                >
                  {"   "} Expunge and retain file
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>
        </form>
      </Fragment>
    );
  }
}

export default DemoExpungement;
